var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVerticalRoadmapLast(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 310.19 1027.74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n        stroke-width: 7px;\r\n        stroke: url(#linear-gradient);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -36.9,
    y1: 525.73,
    x2: 320.89,
    y2: 504.1,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1030.01)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#7d53fe",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#8050fc",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#8c43f6",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#864af9",
    stopOpacity: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#8050fc",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7d53fe",
    stopOpacity: 0.04
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.47,3.5H235.59c39.32,0,71.1,31.66,71.1,70.61S275.11,144.53,236,144.73l-162.61,1.1c-38.72.3-69.89,31.56-69.89,69.91,0,38.55,31.48,69.91,70.39,69.91H236.8c38.61,0,69.89,31.07,69.89,69.42s-31.28,69.41-69.89,69.41H79.93c-42.24,0-76.43,34-76.43,75.91S37.69,576.3,79.93,576.3H229.26c42.74,0,77.43,34.45,77.43,76.9S272,730.11,229.26,730.11H79.93c-42.24,0-76.43,34-76.43,75.9s34.19,75.91,76.43,75.91H235.59c39.22,0,71.1,31.56,71.1,70.62,0,38.75-31.58,70.3-70.69,70.6l-162.61,1.1-68.92-.07"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerticalRoadmapLast);
export default __webpack_public_path__ + "static/media/vertical-roadmap-last.ee05ad0776092e46f07078e63907cd74.svg";
export { ForwardRef as ReactComponent };